export function isBuildDebugEnabled() {
  return typeof BUILD_CONFIG !== 'undefined' && BUILD_CONFIG.debug === true;
}

const DEBUG_VERBOSITY_KEY = 'affine:debug-verbosity';
const DEBUG_VERBOSITY_GLOBAL = '__AFFINE_DEBUG_VERBOSITY__';

function parseDebugVerbosity(value: unknown) {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return Math.max(0, Math.floor(value));
  }
  if (typeof value !== 'string' || value.trim() === '') {
    return null;
  }
  const parsed = Number.parseInt(value, 10);
  return Number.isFinite(parsed) ? Math.max(0, parsed) : null;
}

function readDebugVerbosityFromUrl() {
  const global = globalThis as {
    location?: { search?: string };
    sessionStorage?: Pick<Storage, 'setItem'>;
  };
  const search = global.location?.search;
  if (!search) return null;

  const params = new URLSearchParams(search);
  const value =
    params.get('debug-verbosity') ??
    params.get('debugVerbosity') ??
    params.get('verbosity');
  const parsed = parseDebugVerbosity(value);
  if (parsed !== null) {
    global.sessionStorage?.setItem(DEBUG_VERBOSITY_KEY, String(parsed));
  }
  return parsed;
}

function readDebugVerbosityFromStorage() {
  const global = globalThis as {
    sessionStorage?: Pick<Storage, 'getItem'>;
    localStorage?: Pick<Storage, 'getItem'>;
  };
  return (
    parseDebugVerbosity(global.sessionStorage?.getItem(DEBUG_VERBOSITY_KEY)) ??
    parseDebugVerbosity(global.localStorage?.getItem(DEBUG_VERBOSITY_KEY))
  );
}

export function getDebugVerbosity() {
  const global = globalThis as Record<string, unknown>;
  return (
    readDebugVerbosityFromUrl() ??
    readDebugVerbosityFromStorage() ??
    parseDebugVerbosity(global[DEBUG_VERBOSITY_GLOBAL]) ??
    0
  );
}

export function isDebugVerbosityAtLeast(level: number) {
  return getDebugVerbosity() >= level;
}
